import { render, staticRenderFns } from "./CityTag.vue?vue&type=template&id=50e7e228&scoped=true&"
import script from "./CityTag.vue?vue&type=script&lang=js&"
export * from "./CityTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7e228",
  null
  
)

export default component.exports